import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlmacenComponent } from '../almacen/almacen.component';
import { EventoComponent } from '../evento/evento.component';
@Component({
  selector: 'app-lista-centros-comerciales',
  templateUrl: './lista-centros-comerciales.component.html',
  styleUrls: ['./lista-centros-comerciales.component.scss'],
})
export class ListaCentrosComercialesComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EventoComponent>
  ) {}

  ngOnInit(): void {}

  openAlmacenModal() {
    const dialogRef = this.dialog.open(AlmacenComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
